<script>
  export let id;
  export let value;
  export let current;
  export let label;
  export let showLabel = false;
  export let icon = null;
  export let margin = true;
  export let values;
  export let required = false;

  let resetValue = value || null;
</script>

<div class="form-group" class:in={current === id} class:filled={value} class:margin>
  <!-- icon -->
  {#if icon != null}
    <div class="icon-left choice">
      <i class={icon} />
    </div>
  {/if}

  <!-- label -->
  {#if showLabel}
    <label required for={id}>{label}</label>
  {/if}

  {#each values as v}
    <label class="container" class:checked={value == (v.value || v.id)}>
      {v.label}
      <input type="radio" name={id} bind:group={value} value={(v.value || v.id)} {required} />
    </label>
  {/each}
  <span class="spacer" />
  <div class="icon-right reset">
    <button on:click={() => (value = resetValue)} type="button" class="reset" tabindex="-1">
      <i class="fa fa-times-circle" />
    </button>
  </div>
</div>

<style>
  .form-group {
    display: flex;
    position: relative;
    width: 100%;
    border-radius: 2px;
    background: #efefef;
    line-height: 1;
  }
  .margin.form-group {
    margin-bottom: 15px;
  }

  .readOnly.form-group {
    background: none;
  }

  .in.form-group {
    -webkit-box-shadow: 0 2px 0 var(--primary-light-color);
    box-shadow: 0 2px 0 var(--primary-light-color);
  }
  .in.form-group .icon-left {
    color: var(--primary-color);
  }
  .form-group .icon-left {
    width: 34px;
    padding-top: 10px;
    font-size: 17px;
    font-weight: 400;
    line-height: 1;
    text-align: right;
    background-color: #eee;
    border: 0;
    color: var(--primary-light-color);
  }

  .form-group .icon-right {
    background: 0;
    cursor: pointer;
    padding: 10px 8px 0 5px;
  }

  .form-group .form-control {
    position: relative;
    width: 100%;
    margin-bottom: 0;
    background: #efefef;
  }

  .form-group input {
    -webkit-appearance: none;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #666;
    font-size: 14px;
    height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    resize: none;
    vertical-align: middle;
    width: 100%;
  }

  div {
    padding-top: 0.4em;
    padding-bottom: 0.4em;
  }

  label {
    margin-right: 1em;
    line-height: 2em;
  }

  .choice {
    padding-right: 1em;
  }

  .container {
    display: block;
    position: relative;
    background-color: white;
    border-radius: 15px;
    padding-left: 1em;
    padding-right: 1em;
    margin-right: 1em;
    font-size: 14px;
    line-height: 2em;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .container.checked {
    background-color: var(--primary-light-color);
  }

  /* Hide the browser's default radio button */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  span.spacer {
    flex-grow: 1;
  }

  .form-group button.reset {
    cursor: pointer;
    background: none;
    color: #ccc;
    font-size: 18px;
    border: 0;
    border-radius: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin: 0;
    padding: 0;
    text-align: left;
  }
</style>
